export default __webpack_public_path__ + "static/media/poi_fireStation.3e2d27b0.svg";